"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9029],{

/***/ 9029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ forexCardSection_ForexCardSection; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(5235);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/customerEngagement/index.tsx + 1 modules
var customerEngagement = __webpack_require__(8607);
// EXTERNAL MODULE: ../../libs/utility/src/lib/theme/colors/index.ts
var colors = __webpack_require__(2193);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 6 modules
var hooks = __webpack_require__(6225);
// EXTERNAL MODULE: ../../libs/ui/src/lib/shared-styled-components/index.ts
var shared_styled_components = __webpack_require__(7171);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/BulletList/index.tsx + 1 modules
var BulletList = __webpack_require__(907);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/poweredBy/index.style.ts
var index_style = __webpack_require__(6609);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(5505);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/forexCardInfo/index.style.ts

var LandingTransLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingTransLeft",
  componentId: "e2unrp-0"
})(["background:#fff;border-radius:14px;padding:24px 30px;margin-left:80px;flex-shrink:0;opacity:0;width:350px;"]);
var LandingTransPara = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingTransPara",
  componentId: "e2unrp-1"
})(["font-family:\"Avenir\";font-style:normal;font-weight:500;font-size:22px;line-height:30px;color:#000000;margin-bottom:277px;& .greenText{color:#22936a;margin-bottom:8px;font-weight:700;}"]);
var LandingPoweredBy = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "indexstyle__LandingPoweredBy",
  componentId: "e2unrp-2"
})(["margin:0 10px 0 0;"]);
// EXTERNAL MODULE: ../../libs/ui/src/lib/ui-container/Image/index.tsx + 1 modules
var Image = __webpack_require__(8863);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/forexCardInfo/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var ForexCardInfo = function ForexCardInfo(_ref) {
  var _poweredBy$logos, _poweredBy$logos2;

  var title = _ref.title,
      cardImgs = _ref.cardImgs,
      forexCardBenefits = _ref.forexCardBenefits,
      poweredBy = _ref.poweredBy;
  (0,hooks/* useForexCardAnimation */.eQ)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({}, cardImgs[0]), {}, {
      key: 0,
      id: "bmf_card",
      className: "bmfCard"
    })), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({}, cardImgs[1]), {}, {
      key: 1,
      id: "forex_card",
      className: "forexCard"
    })), /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTransLeft, {
      id: "trans_left",
      children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTransPara, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          dangerouslySetInnerHTML: {
            __html: title
          }
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(BulletList/* BulletList */.D, {
        list: forexCardBenefits,
        bulletColor: colors/* BG_COLOR.black */.VR.black
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(shared_styled_components/* Flex */.kC, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(index_style/* PoweredByText */.P, {
          children: poweredBy === null || poweredBy === void 0 ? void 0 : poweredBy.title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingPoweredBy, {
          children: /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({}, poweredBy === null || poweredBy === void 0 ? void 0 : (_poweredBy$logos = poweredBy.logos) === null || _poweredBy$logos === void 0 ? void 0 : _poweredBy$logos[0]), {}, {
            key: 0
          }))
        }), /*#__PURE__*/(0,react.createElement)(Image/* Image */.E, _objectSpread(_objectSpread({}, poweredBy === null || poweredBy === void 0 ? void 0 : (_poweredBy$logos2 = poweredBy.logos) === null || _poweredBy$logos2 === void 0 ? void 0 : _poweredBy$logos2[1]), {}, {
          key: 1
        }))]
      })]
    })]
  });
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/forexCardSection/ForexCardSection.style.ts

var LandingTrans = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ForexCardSectionstyle__LandingTrans",
  componentId: "sc-13uqop6-0"
})(["display:flex;margin-bottom:90px;position:relative;& input{background:#ffffff;border:1px solid #d2d2d2;border-radius:4px;margin-right:8px;padding:10px;font-weight:400;font-size:14px;line-height:19px;}& input.disable{opacity:0.3;pointer-events:none;}input.focus{outline:none;border:1px solid #008cff !important;}& input.error{border:1px solid red;}.bmfCard{position:absolute;top:260px;right:30px;z-index:28;}.forexCard{width:290px;height:181px;position:absolute;top:60px;right:30px;z-index:26;}"]);
var LandingGreySecWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForexCardSectionstyle__LandingGreySecWrap",
  componentId: "sc-13uqop6-1"
})(["width:1200px;margin:0 auto;background:#f5f5f5;@media only screen and (max-width:768px){width:100%;}"]);
var LandingGreySec = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ForexCardSectionstyle__LandingGreySec",
  componentId: "sc-13uqop6-2"
})(["background:#f5f5f5;padding:105px 0;margin-top:-120px;@media only screen and (max-width:768px){padding:16px;margin-top:80px;}"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/ui-container/forexCardSection/ForexCardSection.tsx


function ForexCardSection_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ForexCardSection_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ForexCardSection_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ForexCardSection_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var ForexCardSection = function ForexCardSection(_ref) {
  var forexCardEngagement = _ref.forexCardEngagement,
      forexCardInfo = _ref.forexCardInfo,
      events = _ref.events;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(LandingGreySec, {
    id: "grey_ref",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(LandingGreySecWrap, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(LandingTrans, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(customerEngagement/* CustomerEngagement */.M, ForexCardSection_objectSpread(ForexCardSection_objectSpread({}, forexCardEngagement), {}, {
          events: events,
          offering: "INR"
        })), /*#__PURE__*/(0,jsx_runtime.jsx)(ForexCardInfo, ForexCardSection_objectSpread({}, forexCardInfo))]
      })
    })
  });
};

/* harmony default export */ var forexCardSection_ForexCardSection = (ForexCardSection);

/***/ })

}]);